import { Link, useLocation } from "wouter";
import { Menu, X, ChevronDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useState, useCallback } from "react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@/components/ui/collapsible";

export function Header() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [location, navigate] = useLocation();
  const isTermsPage = location === "/terms";

  const handleNavigation = useCallback((path: string, e?: React.MouseEvent) => {
    if (e) e.preventDefault();

    if (path.includes("#")) {
      window.location.assign(path);
    } else {
      navigate(path);
    }

    setIsMobileMenuOpen(false);
  }, [navigate]);

  return (
    <header className="fixed top-0 left-0 right-0 z-[1005] border-b border-[#f0c766]/30 bg-[#05170d]/95 text-[#f7edd7] shadow-lg backdrop-blur">
      <div className="container mx-auto flex h-16 items-center justify-between px-4">
        <a
          href="/"
          className="relative z-[1001] text-lg font-black uppercase tracking-[0.18em] text-[#f0c766]"
          onClick={(e) => handleNavigation("/", e)}
        >
          Liquid Stretch
        </a>

        <nav className="hidden items-center gap-5 md:flex">
          {!isTermsPage && (
            <>
              <a
                href="/articles/first-light-to-golden-hour-liquid-stretch"
                className="relative z-[1001] text-sm font-bold text-[#f7edd7] hover:text-[#f0c766]"
                onClick={(e) => handleNavigation("/articles/first-light-to-golden-hour-liquid-stretch", e)}
              >
                Journey
              </a>
              <a
                href="/lab-results"
                className="relative z-[1001] text-sm font-bold text-[#f7edd7] hover:text-[#f0c766]"
                onClick={(e) => handleNavigation("/lab-results", e)}
              >
                Lab Results
              </a>
              <DropdownMenu>
                <DropdownMenuTrigger asChild>
                  <button className="relative z-[1001] flex items-center text-sm font-bold text-[#f7edd7] hover:text-[#f0c766]">
                    About <ChevronDown className="ml-1 h-4 w-4" />
                  </button>
                </DropdownMenuTrigger>
                <DropdownMenuContent className="z-[1006]" align="start">
                  <DropdownMenuItem onClick={() => handleNavigation("/about")}>
                    About Liquid Stretch
                  </DropdownMenuItem>
                  <DropdownMenuItem onClick={() => handleNavigation("/ben-care")}>
                    Ben Care
                  </DropdownMenuItem>
                  <DropdownMenuItem onClick={() => handleNavigation("/legal")}>
                    Is This Legal?
                  </DropdownMenuItem>
                  <DropdownMenuItem onClick={() => handleNavigation("/terms")}>
                    Terms & Conditions
                  </DropdownMenuItem>
                </DropdownMenuContent>
              </DropdownMenu>
            </>
          )}
        </nav>

        <Button
          variant="ghost"
          className="relative z-[1001] gap-2 px-3 text-[#f0c766] hover:bg-[#123820] hover:text-[#f0c766] md:hidden"
          data-menu-button
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        >
          {isMobileMenuOpen ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          <span className="text-sm font-black">Menu</span>
        </Button>
      </div>

      {isMobileMenuOpen && (
        <nav data-mobile-menu className="absolute left-0 top-16 z-[1002] w-full border-t border-[#f0c766]/30 bg-[#05170d] shadow-lg md:hidden">
          <div className="container mx-auto flex flex-col space-y-4 px-4 py-4">
            {!isTermsPage && (
              <>
                <a
                  href="/articles/first-light-to-golden-hour-liquid-stretch"
                  className="text-sm font-bold text-[#f7edd7] hover:text-[#f0c766]"
                  onClick={(e) => handleNavigation("/articles/first-light-to-golden-hour-liquid-stretch", e)}
                >
                  Journey
                </a>
                <a
                  href="/lab-results"
                  className="text-sm font-bold text-[#f7edd7] hover:text-[#f0c766]"
                  onClick={(e) => handleNavigation("/lab-results", e)}
                >
                  Lab Results
                </a>
                <Collapsible className="w-full">
                  <CollapsibleTrigger className="flex w-full items-center justify-between text-sm font-bold text-[#f7edd7]">
                    <span>About</span>
                    <ChevronDown className="h-4 w-4" />
                  </CollapsibleTrigger>
                  <CollapsibleContent className="mt-2 space-y-2 pl-3">
                    <Link href="/about" className="block text-[#f7edd7] hover:text-[#f0c766]">
                      About Liquid Stretch
                    </Link>
                    <Link href="/ben-care" className="block text-[#f7edd7] hover:text-[#f0c766]">
                      Ben Care
                    </Link>
                    <Link href="/legal" className="block text-[#f7edd7] hover:text-[#f0c766]">
                      Is This Legal?
                    </Link>
                    <Link href="/terms" className="block text-[#f7edd7] hover:text-[#f0c766]">
                      Terms & Conditions
                    </Link>
                  </CollapsibleContent>
                </Collapsible>
              </>
            )}
          </div>
        </nav>
      )}
    </header>
  );
}
